module.exports = __webpack_public_path__ + "img/highlight-icon3.b72d33e2.png";